import SvgIcon from "@/components/common/SvgIcon";
import { Typography } from "@/components/kit";
import Toast from "@/components/kit/Toast";
import { useEffect, useRef, useState } from "react";
import { useFormikContext } from "formik";
import { IUser } from "../../types";

const MAX_PROFILE_SIZE_BYTES = 2 * 1024 * 1024; // 5MB

const AddProfilePhoto = () => {
  // const { values, setFieldValue } = useFormikContext<{
  //   icon: File;
  //   ipaFile: File;
  // }>();
  const { setFieldValue, values } = useFormikContext<IUser>();
  const fileHandler = async (file: File) => {
    if (file.size > MAX_PROFILE_SIZE_BYTES) {
      Toast({
        status: "error",
        title: "File too large",
        description: `Profile photo must be under ${MAX_PROFILE_SIZE_BYTES / 1024 / 1024}MB.`,
      });
      return;
    }
    setFieldValue("profile", file);
    // if (!file?.type.includes("android")) {
    //   Toaster({
    //     description: "You must add a .apk file",
    //     status: "error",
    //     title: "Error",
    //   });
    //   return;
    // }
    // setState("file", file);
    // setFieldValue("ipaFile", file);
    // const data = await androidApkParser(file);
    // setFieldValue("originalname", data.application?.label[0]);
    // setFieldValue("version", data.versionName);
    // setFieldValue("icon", base64ToBlob(data.icon, "image/png"));
  };

  const rightBoxRef = useRef<HTMLDivElement | null>(null);
  const [boxSize, setBoxSize] = useState<number>(0);

  useEffect(() => {
    if (!rightBoxRef.current) return;
    const el = rightBoxRef.current;
    const measure = () => setBoxSize(el.offsetHeight);
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return (
    <>
      <div className="border  rounded-xl border-gray-100 w-full pt-3 bg-gray-50 pb-4 px-4">
        {!values.profile && (
          <label
            htmlFor="apkPicker"
            onDrop={(e) => {
              e.preventDefault();
              const selectedFile = e.dataTransfer.files?.item(0);
              if (!selectedFile) return;
              fileHandler(selectedFile);
            }}
            onDragOver={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            className="py- flex gap-x-4 items-center  cursor-pointer "
          >
            <div className="relative size-12 rounded-full flex items-center justify-center">
              <svg
                className="absolute inset-0"
                viewBox="0 0 48 48"
                width="48"
                height="48"
                aria-hidden
              >
                <circle
                  cx="24"
                  cy="24"
                  r="22.5"
                  fill="none"
                  stroke="#CACACD"
                  strokeWidth="1"
                  strokeDasharray="4 8"
                />
              </svg>
              <SvgIcon className="w-6 h-6 fill-gray-300" iconName="cameraAdd" />
            </div>
            <div className="flex flex-col gap-y-1">
              <Typography
                className="!text-blue-700"
                variant="Body1-Regular"
                block
              >
                Drag and drop or browse to choose a file{" "}
              </Typography>
              <Typography className="!text-gray-300" variant="Caption1-Regular">
                Only .png, .jpg, .jpeg (maximum 2 MB)
              </Typography>
            </div>
          </label>
        )}
        {values.profile && (
          <div className="flex items-stretch gap-x-4">
            <div
              className="border rounded-lg flex items-center justify-center overflow-hidden bg-white"
              style={{ width: boxSize || 96, height: boxSize || 96 }}
            >
              <img
                src={
                  typeof values.profile === "string"
                    ? values.profile
                    : URL.createObjectURL(values.profile)
                }
                alt="preview"
                className="size-10 object-contain"
              />

              <SvgIcon className="w-8 h-8 fill-gray-300" iconName="image" />
            </div>
            <div
              ref={rightBoxRef}
              className="py-7 flex-1 flex justify-center gap-x-4 border border-dashed rounded-lg"
            >
              <SvgIcon className="w-10 h-10 fill-gray-800" iconName="file" />
              <div className="flex flex-col gap-y-1">
                <Typography
                  className="!text-gray-500"
                  variant="Body1-Regular"
                  block
                >
                  {/* {file.name} */}
                </Typography>
                <Typography className="!text-[#56DA6B]" variant="Body1-Regular">
                  Your file successfully uploaded
                </Typography>
              </div>
              <div className="flex items-center gap-x-2">
                <SvgIcon
                  className="cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    // setState("file", undefined);
                    setFieldValue("profile", undefined);
                  }}
                  iconName="trash"
                />
                <label htmlFor="apkPicker">
                  <SvgIcon className="cursor-pointer" iconName="upload" />
                </label>
              </div>
            </div>
          </div>
        )}
      </div>
      <input
        className="hidden"
        // disabled={!!values.ipaFile}
        accept=".png, .jpg, .jpeg"
        onChange={(e) => {
          if (e?.target?.files?.[0]) {
            fileHandler(e.target.files[0]);
          }
        }}
        type="file"
        id="apkPicker"
      />
    </>
  );
};

export default AddProfilePhoto;
